import { useEffect, useRef, useState } from 'react';
import './CSS/AboutUs.css';
import kind from '../assets/kind.jpg';
import kind2 from '../assets/kind2.jpg';
import { useTranslation } from 'react-i18next';

const AboutUs: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const aboutRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const currentRef = aboutRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div ref={aboutRef} className={`about-us ${isVisible ? 'fade-in-section' : ''}`}>
      <div className="about-content">
        <h3 className="about-subtitle">{t("About")}</h3>
        <h1 className="about-title">{t("Kindness")}</h1>
        <p className="about-description">{t("ImpactParagraph")}</p>
        <a href="/about" className="learn-more modern-button">{t("LearnMore")}</a>
        <div className="about-images">
          <div className="about-image-wrapper">
            <img src={kind} alt="About1" />
            <div className="image-overlay-about"></div>
          </div>
          <div className="about-image-wrapper">
            <img src={kind2} alt="About2" />
            <div className="image-overlay-about"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
